import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { always, compose } from 'ramda';
import { ReEnrollmentChecklistPlan } from 're-enrollment-checklist/re-enrollment-checklist.types';
import { ChecklistCard } from 're-enrollment-checklist/ChecklistCard';
import setLegacyChecklistCompletionProgress from 'shared/utils/set-legacy-checklist-completion-progress';

function FsaPlanCard ({ plan }: { plan: ReEnrollmentChecklistPlan; }) {
  const icon = <AddShoppingCartIcon style={ { fontSize: 32 } } />;
  const history = useHistory();
  const buttons = (
    <div className="justify-start" data-testid="fsa-plan-buttons">
      <Button
        variant="outlined"
        className="mr-5"
        data-testid="fsa-link"
        onClick={compose(
          history.push,
          always(`/reenrollment-checklist/fsa/${plan.planYearId}`),
        )}
      >
        <div className="justify-start">
          <div>Flexible Spending Account</div>
        </div>
      </Button>
    </div>
  );

  return (
    <ChecklistCard
      icon={icon}
      title="Flexible Spending Account"
      planYearStart={plan.planYearStart}
      planYearEnd={plan.planYearEnd}
      buttons={buttons}
      progress={setLegacyChecklistCompletionProgress(plan.legacyChecklistComplete)}
    />
  );
}

export default FsaPlanCard;

